module.exports = __webpack_public_path__ + "static/img/img-banner.fed1709d.png";